module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Med.woff?v=628a46dd3a40225a3d1e2870e54f8781";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Med.woff
// module id = 663
// module chunks = 0